export default __webpack_public_path__ + "files/media/member-ar-m.608c24b5.jpg";